import { httpMethodType, ConnectionService } from "./Connecion.service";

const RESOURCE = 'oauth';

const oauthConfig = {
  'client_id': 'CLCVXYFKASRKRPAV',
  'client_secret': 'a93e6f9718d97bc9c76b3d3ff73ef3d4',
  'grant_type': 'password'
}

class OauthService extends ConnectionService {
  constructor() {
    super();
    this.basedUrl = `/${RESOURCE}`
  }

  async getPublicKey() {
    const url = `${this.basedUrl}/publicKey`;
    return await super.sendRequest(url, {}, true);
  }

  async getToken(username, password) {
    const url = `${this.basedUrl}/token`;
    const detail = {
      ...oauthConfig,
      username: encodeURIComponent(username),
      password: encodeURIComponent(password)
    }

    const formBody = [];
    for (let item in detail) {
      formBody.push(`${item}=${detail[item]}`);
    }

    return await super.sendRequest(
      url,
      {
        method: httpMethodType.post,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: formBody.join('&')
      },
      true
    );
  }
}

export default new OauthService();